import { FC, useEffect } from 'react';
import { clsx } from 'clsx';
import { useSchedule } from 'features/useSchedule';
import { useAppSelector } from 'shared/lib';

import { ContainerSchedule } from '../containerSchedule';
import { DateRow } from '../dateRow';
import { useScroll } from '../hooks';
import { makeColumns } from '../lib';
import { SkeletonDateHeader } from '../skeletonDateHeader';
import { SkeletonSchedule } from '../skeletonSchedule';

import styles from './styles.module.scss';

export const StageSchedule: FC = () => {
  const { startIntervalDate, isGroupSchedule, endIntervalDate } =
    useAppSelector((state) => state.schedulePublicReducer);

  const { groupSchedule, isSkeleton, teacherSchedule, filterSchedule } =
    useSchedule();

  const {
    containerScheduleRef,
    dateHeaderRef,
    handleScroll,
    isScrolledDown,
    setIsScrolledDown,
  } = useScroll();

  useEffect(() => {
    filterSchedule(startIntervalDate, endIntervalDate);
  }, [startIntervalDate, endIntervalDate]);

  return (
    <div className={styles['stage-schedule']}>
      <div
        className={clsx(styles['stage-schedule__date-header'], {
          [styles['stage-schedule__date-header_scrolled']]: isScrolledDown,
        })}
        ref={dateHeaderRef}
        style={{ overflow: 'hidden' }}
      >
        {isSkeleton ? (
          <SkeletonDateHeader isScrolledDown={isScrolledDown} />
        ) : (
          <DateRow
            data={isGroupSchedule ? groupSchedule : teacherSchedule}
            isScrolledDown={isScrolledDown}
          />
        )}
      </div>
      <ContainerSchedule
        ref={containerScheduleRef}
        onScroll={handleScroll}
        setIsScrolledDown={setIsScrolledDown}
        isScrolledDown={isScrolledDown}
      >
        {isSkeleton ? (
          <SkeletonSchedule />
        ) : (
          makeColumns(isGroupSchedule ? groupSchedule : teacherSchedule)
        )}
      </ContainerSchedule>
    </div>
  );
};
